module.exports = __webpack_public_path__ + "static/sound/breathing4.56827869a.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/fx/breathing/breathing4.mp3
// module id = 479
// module chunks = 1